import {Controller} from '@hotwired/stimulus';

/**
 * Intro d'écran (`page_help()`, `Lang::help()`) : « Masquer l'aide » la retire, et
 * elle reste masquée dans ce navigateur pour cet utilisateur. Sans `localStorage` (navigation privée,
 * stockage bloqué), le masquage ne vaut que pour la page affichée.
 *
 * Un autre encart masquable reprend le contrôleur avec sa propre entrée de `localStorage` : `storageKey` en donne le
 * nom complet (à la place de `key` et `user`), `mark` la valeur qui le masque.
 *
 *     <div {{ stimulus_controller('page-help', {storageKey: 'booking-stop-message-' ~ siteId, mark: 'hide'}) }}>
 *         <a href="#" {{ stimulus_action('page-help', 'hide:prevent') }}>…</a>
 *     </div>
 */
export default class extends Controller {
  static values = {key: String, user: String, storageKey: String, mark: {type: String, default: '1'}};

  connect() {
    if (this.read() === this.markValue) {
      this.element.remove();
    }
  }

  hide() {
    try {
      localStorage.setItem(this.storageKey, this.markValue);
    } catch {
      // le masquage ne survivra pas au rechargement
    }

    this.element.remove();
  }

  read() {
    try {
      return localStorage.getItem(this.storageKey);
    } catch {
      return null;
    }
  }

  get storageKey() {
    if (this.hasStorageKeyValue) {
      return this.storageKeyValue;
    }

    return `page-help-hidden:${this.userValue}:${this.keyValue}`;
  }
}
